// extracted by css-extract-rspack-plugin
export default {"Label":"YAWau"};